import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ProfileFormValues } from "@/hooks/profile";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Building2 } from "lucide-react";

interface UniversitySwapSettingsProps {
  form: UseFormReturn<ProfileFormValues>;
}

const UniversitySwapSettings: React.FC<UniversitySwapSettingsProps> = ({ form }) => {
  const universityId = form.watch("university_id");
  const hasUniversity = !!universityId;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Building2 className="h-5 w-5 text-primary" />
        <h3 className="font-medium">University Swap Preferences</h3>
      </div>

      <FormField
        control={form.control}
        name="university_only_swaps"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">
                University-Only Swaps
              </FormLabel>
              <FormDescription>
                {hasUniversity 
                  ? "Only show reagents from users at your university. Other users at your university will also see your reagents exclusively."
                  : "Set your university in your profile to enable this feature."
                }
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={!!field.value}
                onCheckedChange={field.onChange}
                disabled={!hasUniversity}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {!hasUniversity && (
        <p className="text-sm text-muted-foreground">
          To enable university-restricted swapping, please select your university in the Personal tab.
        </p>
      )}
    </div>
  );
};

export default UniversitySwapSettings;
